/*! empai-swatch-fix v2 */
(function(){
  var SWATCHES={
    blue:"#1c7ed6",green:"#2f9e44",orange:"#f76707",yellow:"#f59f00",red:"#e03131",
    pink:"#e64980",purple:"#7048e8",gray:"#868e96",grey:"#868e96",bronze:"#a8793d",
    "bronze translucent":"#c49a6c","bronze transparent":"#d4b896",
    "gray translucent":"#adb5bd","grey translucent":"#adb5bd",
    "gray transparent":"#ced4da","grey transparent":"#ced4da",
    "fluorescent blue":"#15aabf","fluorescent green":"#40c057",
    "fluorescent orange":"#fd7e14","fluorescent red":"#fa5252",
    black:"#111111",white:"#f5f5f5",silver:"#C0C0C0",gold:"#D4AF37"
  };
  function key(s){return String(s||"").trim().toLowerCase().replace(/[_/]+/g," ").replace(/-/g," ").replace(/\s+/g," ");}
  function paint(){
    var root=document.getElementById("EmpaiLinkedPicker");
    if(!root) return;
    root.querySelectorAll(".empai-linked-picker__swatch").forEach(function(btn){
      var raw=btn.getAttribute("data-color")||"";
      if(!raw){
        var label=btn.querySelector("span:not(.empai-linked-picker__dot)");
        raw=(btn.getAttribute("title")||(label&&label.textContent)||btn.textContent||"").trim();
      }
      var bg=SWATCHES[key(raw)];
      if(!bg) return;
      var dot=btn.querySelector(".empai-linked-picker__dot");
      if(!dot) return;
      dot.style.setProperty("background", bg, "important");
      dot.style.setProperty("background-color", bg, "important");
    });
  }
  function start(){
    paint();
    var root=document.getElementById("EmpaiLinkedPicker");
    if(root&&typeof MutationObserver!=="undefined"){
      new MutationObserver(paint).observe(root,{childList:true,subtree:true});
    }
    [50,200,600,1500].forEach(function(ms){ setTimeout(paint, ms); });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
